import React, { FC } from "react";
import { Block } from "kanopi-components/Block";
import { PortalRow } from "kanopi-components/PortalRow";
import { StyledLink } from "kanopi-components/Link/StyledLink";
import { useContactUs } from "./useContactUs";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import {
  HeadingMedium,
  HeadingSmall,
  ParagraphSmall,
} from "kanopi-components/typography";

export const ContactUsContent: FC = () => {
  const { contactUs } = useContactUs();
  const sendEmail = (e) => {
    e.preventDefault();
    window.open(`mailto:${contactUs?.emailAddress}`, "_blank");
  };
  const [, theme] = useStyletron();
  return (
    <Block
      display="flex"
      flexDirection="column"
      alignContent="center"
      alignItems="center"
    >
      <PortalRow>
        <HeadingMedium margin={0}>Contact us</HeadingMedium>
      </PortalRow>
      {contactUs?.operatingHours && (
        <PortalRow>
          <HeadingSmall margin={0} center color={theme.colors.contentTertiary}>
            Support operation hours
          </HeadingSmall>
          <ParagraphSmall center color={theme.colors.contentTertiary}>
            {contactUs?.operatingHours}
          </ParagraphSmall>
        </PortalRow>
      )}
      {contactUs?.phoneDisplay && (
        <PortalRow>
          <HeadingSmall margin={0} center color={theme.colors.contentTertiary}>
            Phone
          </HeadingSmall>
          <ParagraphSmall center color={theme.colors.contentTertiary}>
            {contactUs?.phoneDisplay}
          </ParagraphSmall>
        </PortalRow>
      )}
      {contactUs?.emailAddress && (
        <PortalRow>
          <HeadingSmall margin={0} center color={theme.colors.contentTertiary}>
            Email
          </HeadingSmall>
          <StyledLink href="#" onClick={sendEmail}>
            <ParagraphSmall color="inherit">{contactUs?.emailAddress}</ParagraphSmall>
          </StyledLink>
        </PortalRow>
      )}
      {contactUs?.website && (
        <PortalRow>
          <StyledLink href={contactUs?.website || "#"} target="_blank">
            {contactUs?.website}
          </StyledLink>
        </PortalRow>
      )}
    </Block>
  );
};
